// React 
import React, { useState, useEffect, useReducer } from 'react';
import styled from 'styled-components/macro';
import { Link, useNavigate } from 'react-router-dom';
import ReactHtmlParser from 'html-react-parser';

// utils
import { debounce } from 'lodash';
import { IconUser, IconLock, palette } from '@mirinae/react-ui';
import { ExternalLinks, Validation } from '@mirinae/js-utils';
import { authAPI } from '@mirinae/react-auth';
//layouts
import { 
    FormRow, FormLabel, FormEmailWrapper, FormPasswordWrapper, FormProfileWrapper, FormIcon, FormError, PopupContentDesc,
    NestedLink, AuthPopupLayer, PopupTitle, PopupTitleWrapper, PopupTitleDesc, 
    AuthColDiv, AuthColLinks, AuthButton, AuthColForms, AuthPopupWrapper, PopupBody, FormBottom, InputContainer,
} from '@mirinae/explorer/components/userauth/AuthPopupLayer';
import {
    FirstRowMessage,
    LoginRightBox,
    RevertMessage,
    SecondRowMessage,
    ThirdRowMessage,
} from '@mirinae/explorer/components/userauth/LoginLayer';

import { useAppVersionStore } from '@mirinae/stores/appVersion';
import GTM from '@mirinae/shared/apis/GoogleAnalytics';

// import { ErrorMessage } from '@mirinae/explorer/components/userauth/InputForm';
import { LogoHolder } from '@mirinae/explorer/components/userauth/UserAuthComponent';
import { ReactComponent as IconMirinaeLogo } from '@mirinae/explorer/components/assets/icon-mirinae-logo.svg';
import { ReactComponent as IconEnterEmail } from '@mirinae/explorer/components/assets/icon-enter-email.svg';

import { explorerPaths, authPaths } from '@mirinae/shared/defines/paths';
import Localization from '@mirinae/shared/il8n';
import { ReactComponent as IconVisible } from '@mirinae/explorer/components/assets/visibility.svg';
import { currentTrialDays } from '@mirinae/shared/defines/datas';

import SnsButtonsGroupContainer from './SnsButtonsGroupContainer';


const { invalidEmail, invalidPassword, isContinuousString } = Validation;

export const SNSFormError = styled.div`
    height: 12px;
    line-height: 14px;
    font-size: 10px;
    color: ${palette.warning.default};
    text-align: center;
    p {
        font-weight: 400;
        font-size: 10px;
        line-height: 12px;
        color: ${palette.warning.default};
    }
`;

const ResendLink = styled.div`
    cursor: pointer;
    color: #48A9A6;
    text-align: center;
    font-size: 13px;
    font-weight: 700;
    text-decoration-line: underline;
`;

const CheckTitle = styled.div`
    color: #3C3C3B;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
`;

const initialFormState = {
    name: '',
    email: '',
    password: '',
    agree: false,
};

const formReducer = (state, action) => {
    switch (action.type) {
    case 'HANDLE INPUT TEXT':
        return {
            ...state,
            [action.field]: action.payload || '',
        };
    case 'CHECK CONSENT':
        return {
            ...state,
            hasConsented: !state.hasConsented,
        };
    default: return state;
    }
};

const SignUpLayerContainer = (props) => {
    const [formState, dispatch] = useReducer(formReducer, initialFormState);
    // const isEmailSignupTheme = props.theme === 'emailSignup';
    const isApp = useAppVersionStore(state => state.isApp);
    const defaultError = {
        email: '',
        password: '',
        correcting: false,
    };

    const defaultFocuseState = {
        email: false, password: false, userName: false,
    };

    const [errors, setErrors] = useState(defaultError);
    const [failMessage, setFailMessage] = useState('');
    const [formFocus, setFormFocus] = useState(defaultFocuseState);
    const [userFound, setUserFound] = useState(false);
    const [userFoundLoginType, setUserFoundLoginType] = useState('');
    const [deletedAccount, setDeletedAccount] = useState(false);
    const currentLanguage = Localization.getLanguage();
    const [visiblePW, setVisiblePW] = useState(false);

    const navigate = useNavigate();
    authAPI.setHistory(window.history);
    const isInvalidEmail = formState.email === '' || invalidEmail(formState.email);
    const isInvalidPassword = invalidPassword(formState.password);
    const isNameEmpty = formState.userName === '';
    const [disabled, setDisabled] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const areInValidFields = userFound || isInvalidPassword || isNameEmpty;
    const step = props.step;

    // form validation
    const validate = () => {
        const currentErrors = {};
        if (!formState.email) {
            currentErrors.email = Localization['fe-required'];
        } else if (Validation.invalidEmail(formState.email)) {
            currentErrors.email = Localization['fe-invalidEmail'];
        } else {
            currentErrors.email = '';
        }

        if (!formState.password) {
            currentErrors.password = Localization['fe-required'];
        } else {
            currentErrors.password = '';
        }

        currentErrors.correcting = Boolean(currentErrors.email);
        setErrors(currentErrors);
        
        return !currentErrors.correcting;
    };
        // if (!formState.email.trim()) {
        //     currentErrors.email = Localization['fe-required'];
        // } else if (invalidEmail(formState.email)) {
        //     currentErrors.email = Localization['fe-invalidEmail'];
        // } else {
        //     currentErrors.email = '';
        // }
        // if (invalidPassword(formState.password)) {
        //     currentErrors.password = Localization['fe-invalidPw1'];
        //     dispatch({  
        //         type: 'HANDLE INPUT TEXT',
        //         field: 'password',
        //         payload: '',
        //     });
        // } else if (isContinuousString(formState.password)) {
        //     currentErrors.password = Localization['fe-invalidPw1'];
        //     dispatch({  
        //         type: 'HANDLE INPUT TEXT',
        //         field: 'password',
        //         payload: '',
        //     });
        // } else {
        //     currentErrors.password = '';
        // }

    //     currentErrors.correcting = Boolean(currentErrors.email || currentErrors.password || ((isEmailSignupTheme && currentErrors.confirmPassword) || currentErrors.agree));
    //     setErrors(currentErrors);
    //     return !currentErrors.correcting;
    // };

    // not being used at the moment
    // handle consent checkbox
    // const checkBoxChanged = (e) => {
    //     if (errors.agree) {
    //         setErrors({ ...errors, agree: '' });
    //     }
    //     dispatch({
    //         type: 'CHECK CONSENT',
    //         field: e.target.name,
    //         payload: e.target.value,
    //     });
    // };

    const onFailure = (error) => {
        const loginType = (error.loginType || 'Unknown').replace(/^(.)(.*)/, (m, g1, g2) => `${g1.toUpperCase()}${g2}`).replace('Local', 'email/password');
        setFailMessage(error.errCode ? Localization[`err-${error.errCode}`].replace('{loginType}', loginType) : error.message);
    };

    // handle change on form value
    const handleTextChange = (e) => {
        dispatch({
            type: 'HANDLE INPUT TEXT',
            field: e.target.name,
            payload: e.target.value,
        });
    };
    
    const inputFormBlur = (event) => {
        if (errors[event.target.name]) {
            validate();
        }
        setFormFocus(defaultFocuseState);
    };

    const inputFormFocus = (event) => {
        setFormFocus({ ...defaultFocuseState, [event.target.name]: true });
    };

    const signUpClicked = () => {
        if (!validate()) return;
        setDisabled(true);
        // send an API request to make an account fot a guest user(role stays as a guest)
        authAPI.signupLocal(formState).then(response => {
            if (response.data) {
                // navigate(`${authPaths.login}?step=2`);
                GTM.userAction('signup', { type: 'email' }, 'explorer');
                handleStart();
                // handleVerficationButton();  why is this being called, it is done automatically server-side hanfle the signup call
                console.log('account created');
            } else {
                onFailure(response.error);
            }
            setDisabled(false);
            // Event('Signup', 'email', isApp ? 'app' : 'web');
            GTM.userAction('click-email-signup', { },  'explorer');
        });
    };

    const handleStart = () => {
        if (!validate()) return;
        setFailMessage('');
        // increment step by 1
        if (step < 3) props.setStep(step + 1);
    };

    const handleVerficationButton = async () => {
        // Disable the button
        setIsButtonDisabled(true);
        try {
            // Call your API endpoint to send the verification email here
            // event.preventDefault();
            const response = await fetch('/api/auth/signup/send-verification', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: formState.email }),
            });
    
            // Check for errors in the response
            if (!response.ok) {
                throw new Error('Failed to send verification email');
            }

            const data = await response.json();
            console.log(data);
            console.log('Email sent to', formState.email);

        } catch (error) {
            console.error(error);
        } finally {
            // Wait for a certain amount of time (e.g., 3 seconds) before re-enabling the button
            setTimeout(() => {
                setIsButtonDisabled(false);
            }, 3000);
        }
    };
    
    // const handleChangeEmail = () => {
    //     console.log('handleChangeEmail clicked!');
    // };

    // debouncer for email check api call for local signup users.
    const debounceOnChange = debounce(() => {
        authAPI.checkLocalEmail(formState.email).then((email) => { 
            if (email.data.exist) {
                setUserFound(true);
                setUserFoundLoginType((email.data.loginType || 'Unknown').replace(/^(.)(.*)/, (m, g1, g2) => `${g1.toUpperCase()}${g2}`).replace('Local', 'email/password'));
                setDeletedAccount(email.data.status === 'deleted');
            } else {
                setUserFound(false);
            }
        }).catch((error) => {
            console.log(error);
        });
    }, 500);

    const twitterHandler = (response) => {
        response.json().then(async body => {
            await authAPI.responseTwitter(JSON.stringify(body).split('response:')[0], formState.remember, explorerPaths.home, props.loginCallbak);
        });
        // if (props.loginCallbak) props.loginCallbak();
        Event('Login', 'twitter', isApp ? 'app' : 'web');
    };

    // check whether or not the input email exists in the database
    useEffect(() => {
        if (!isInvalidEmail) debounceOnChange();
    }, [formState.email]);

    // useEffect(() => {
    //     const guestMode = !user.name || user.name === 'Guest';
    //     if (!guestMode) {
    //         navigate(explorerPaths.home);
    //     } else {
    //         const query = qs.parse(history.location.search, { ignoreQueryPrefix: true });
    //         if (!isEmailSignupTheme && query.step === '2') {
    //             setLoginStep(prev => ({ ...prev, step: '2', isSingle: true }));
    //         }
    //     }
    // }, [userContext]);
    
    // useEffect(() => {
    //     setFormData(defaultFormData);
    //     setErrors(defaultError);
    //     setFailMessage('');
    //     setFormData({ ...formData, remember: props.remember });
    // }, []);

    // const handleClickSignUp = () => {
    //     if (location.pathname.includes('player')) {
    //         GTM.userAction('click-signup-lesson-start', { },  'explorer');
    //     }
    // };

    useEffect(() => {
        GTM.pageView('signup', { },  'explorer');
        // check for errors in query params, possiblly from mirinae-react-auth SNS login completion checking
    }, []);

    const onClickSignUp = () => {
        GTM.userAction('click-signup', { },  'explorer');
    };

    return (
        <>
            <AuthPopupLayer>
                {step === 0 && (
                    <AuthPopupWrapper>
                        <LogoHolder href={explorerPaths.home}>
                            <IconMirinaeLogo />
                        </LogoHolder>
                        <PopupTitleWrapper>
                            <PopupTitle>{Localization['signup-zero-title']}</PopupTitle>
                        </PopupTitleWrapper>
                        <AuthColForms>
                            <FormRow>
                                <InputContainer>
                                    <FormLabel htmlFor="signup-email"> {Localization['label-email']} </FormLabel>
                                    <FormEmailWrapper userFound={userFound && userFound} isFocused={formFocus.email === true}>
                                        <FormIcon><IconUser width="10" height="11" color={formFocus.email ? '#48a9a6' : '#979797'} /></FormIcon>
                                        <input
                                            type="email" name="email" maxLength="100"
                                            value={formState.email} id="signup-email"
                                            onChange={(e) => handleTextChange(e)}
                                            onBlur={inputFormBlur} onFocus={inputFormFocus} placeholder="Enter Your email address" />
                                    </FormEmailWrapper>
                                    <FormError>
                                        {userFound && <p>{Localization[deletedAccount ? 'err-A005d' : 'err-A005'].replace('{loginType}', userFoundLoginType)}</p>}
                                    </FormError>
                                </InputContainer>
                            </FormRow>
                        </AuthColForms>
                        <FormBottom>
                            <AuthButton>
                                <button type="button" disabled={isInvalidEmail || userFound} onClick={e => handleStart(e)}>{Localization['get-started-btn']}</button>
                            </AuthButton>
                            <AuthColLinks>
                                {Localization['have-account-text']}
                                <Link reloadDocument to={authPaths.login} replace onClick={() => GTM.userAction('click-login')}>
                                    <button type="button">{Localization['rp-login']}</button>
                                </Link>
                            </AuthColLinks>
                        </FormBottom>
                        <AuthColDiv>OR</AuthColDiv>
                        <SnsButtonsGroupContainer
                            {...props}
                            onFailure={onFailure}
                            isApp={isApp}
                            formState={formState}
                            twitterHandler={twitterHandler}
                        />
                        { failMessage && (
                            <SNSFormError>
                                {failMessage}
                            </SNSFormError>
                        )}
                    </AuthPopupWrapper>
                )}
                {step === 1 && (
                    <AuthPopupWrapper>
                        <LogoHolder href={explorerPaths.home}>
                            <IconMirinaeLogo />
                        </LogoHolder>
                        <PopupTitleWrapper>
                            <PopupTitle>{Localization['signup-one-title']}</PopupTitle>
                        </PopupTitleWrapper>
                        <FormRow>
                            <InputContainer>
                                <FormLabel htmlFor="signup-email">{ step === 0 ? Localization['label-email'] : ReactHtmlParser(Localization['label-your-email'])}</FormLabel>
                                <FormEmailWrapper userFound={userFound && userFound} isFocused={formFocus.email === true}>
                                    <FormIcon><IconUser width="10" height="11" color={formFocus.email ? '#48a9a6' : '#979797'} /></FormIcon>
                                    <input
                                        type="email" name="email" maxLength="100"
                                        value={formState.email} id="signup-email"
                                        onChange={handleTextChange}
                                        onBlur={inputFormBlur} onFocus={inputFormFocus} placeholder={Localization['signup-one-email-placeholder']}
                                    />
                                </FormEmailWrapper>
                                <FormError>
                                    {userFound && <p>{Localization[deletedAccount ? 'err-A005d' : 'err-A005'].replace('{loginType}', userFoundLoginType)}</p>}
                                </FormError>
                            </InputContainer>
                            <InputContainer>
                                <FormLabel htmlFor="signup-name">{Localization['signup-one-profilename-input']}</FormLabel>
                                <FormProfileWrapper isFocused={formFocus.userName === true}>
                                    <input
                                        type="text" name="userName" maxLength="50"
                                        value={formState.userName} id="signup-name"
                                        onChange={handleTextChange}
                                        onBlur={inputFormBlur} onFocus={inputFormFocus} placeholder={Localization['signup-one-profile-placeholder']}
                                    />
                                </FormProfileWrapper>
                            </InputContainer>
                            <InputContainer>
                                <FormLabel htmlFor="signup-pw">{Localization['su-password']}</FormLabel>
                                <FormPasswordWrapper isFocused={formFocus.password === true}>
                                    <FormIcon><IconLock color={formFocus.password ? '#48a9a6' : '#979797'} /></FormIcon>
                                    <input
                                        type={visiblePW ? 'text' : 'password'} name="password" maxLength="20"
                                        value={formState.password} id="signup-pw"
                                        onChange={handleTextChange}
                                        onBlur={inputFormBlur} onFocus={inputFormFocus}
                                        // onKeyDown={e => { if (e.key === 'Enter') { console.log(e.key); } }}
                                    />
                                    <FormIcon style={{ marginRight: 0 }} onClick={() => setVisiblePW(!visiblePW)}><IconVisible /></FormIcon>
                                </FormPasswordWrapper>
                            </InputContainer>
                        </FormRow>
                        <FormBottom>
                            <NestedLink>
                                {Localization['sign-up-consent']} <a href={ExternalLinks.TermsAndConditions} target="_blank" rel="noreferrer">{Localization.tnc}</a> and <a href={ExternalLinks.PrivacyPolicy} target="_blank" rel="noreferrer">Privacy Policy</a>
                                {/* <CheckboxForm name="agree" value={formState.agree} onClick={checkBoxChanged}>{ReactHtmlParser(Localization.formatString(Localization['su-agreement'], ExternalLinks.TermsAndConditions, ExternalLinks.PrivacyPolicy))}</CheckboxForm>  */}
                            </NestedLink>
                            <FormError>
                                {failMessage}
                            </FormError>
                            <AuthButton>
                                <button type="button" disabled={areInValidFields} onClick={signUpClicked}>{Localization['auth-signup']}</button>
                            </AuthButton>
                            <AuthColLinks>
                                {Localization['have-account-text']}
                                <Link reloadDocument to={authPaths.login} replace onClick={() => GTM.userAction('click-login')}>
                                    <button type="button" onClick={() => console.log('clicked')}>{Localization['rp-login']}</button>
                                </Link>
                            </AuthColLinks>
                        </FormBottom>
                    </AuthPopupWrapper>
                )}
                {/* {
                    this is a step for SNS signed-up users that are missing email addresses  NOT YET
                    step === 2 && (
                        <AuthPopupWrapper>
                            <LogoHolder>
                                <IconEnterEmail />
                            </LogoHolder>
                            <PopupBody>
                                <PopupTitle>{Localization['signup-two-title']}</PopupTitle>
                                <PopupContentDesc>{Localization['signup-two-desc']}</PopupContentDesc>
                            </PopupBody>
                            <FormRow>
                                <InputContainer>
                                    <FormLabel htmlFor="enter-email-address">{Localization['su-email']}</FormLabel>
                                    <FormEmailWrapper>
                                        <FormIcon><IconUser width="10" height="11" color={formFocus.email ? '#48a9a6' : '#979797'} /></FormIcon>
                                        {user ? (
                                           <input
                                               readOnly
                                               type="email" name="email" maxLength="100"
                                               value={formState.email} id="signup-email"
                                               onChange={(e) => handleTextChange(e)}
                                               onBlur={inputFormBlur} onFocus={inputFormFocus} placeholder="Enter Your email address" />
                                        )
                                           : (
                                               <input
                                                   readOnly
                                                   type="email" name="email" maxLength="100"
                                                   value={formState.email} id="signup-email"
                                                   onChange={(e) => handleTextChange(e)}
                                                   onBlur={inputFormBlur} onFocus={inputFormFocus} placeholder="Enter Your email address" />
                                           )}
                                    </FormEmailWrapper>
                                </InputContainer>
                            </FormRow>
                            <AuthButton>
                                <button type="button" disabled={isInvalidEmail || userFound} onClick={handleVerficationButton}>{Localization['signup-verify-button']}</button>
                            </AuthButton>
                        </AuthPopupWrapper>
                    )
                } */}
                {step === 2 && (
                    <AuthPopupWrapper>
                        <LogoHolder>
                            <IconEnterEmail />
                        </LogoHolder>
                        <PopupBody>
                            <CheckTitle>{Localization['signup-three-title ']}</CheckTitle>
                            <PopupContentDesc>{Localization['signup-three-desc']}</PopupContentDesc>
                        </PopupBody>
                        <AuthButton>
                            <button type="button" disabled={isButtonDisabled} onClick={() => navigate(authPaths.login)}>{Localization['login-leftbox-welcome-v1.1']}</button>
                        </AuthButton>
                        <ResendLink onClick={handleVerficationButton}>{Localization['signup-send-again']}</ResendLink>
                        {/* <AuthColLinks>
                            <button type="button" onClick={handleChangeEmail}>{Localization['signup-change-email']}</button>
                        </AuthColLinks> */}
                    </AuthPopupWrapper>
                )}
                {/*<RevertMessage>*/}
                {/*    <p>{ReactHtmlParser(Localization['login-rightbox-row-3-1'])}</p>*/}
                {/*    <p>{ReactHtmlParser(Localization['login-rightbox-row-3-2'])}</p>*/}
                {/*</RevertMessage>*/}
            </AuthPopupLayer>

            {/*<LoginRightBox>*/}
            {/*    <FirstRowMessage>*/}
            {/*        <p>{Localization['login-rightbox-row-1'].replace('{trialDays}', currentTrialDays)}</p>*/}
            {/*    </FirstRowMessage>*/}

            {/*    <SecondRowMessage>*/}
            {/*        {ReactHtmlParser(Localization['login-rightbox-row-2'])}*/}
            {/*    </SecondRowMessage>*/}

            {/*    <ThirdRowMessage>*/}
            {/*        <p>{ReactHtmlParser(Localization['login-rightbox-row-3-1'])}</p>*/}
            {/*        <p>{ReactHtmlParser(Localization['login-rightbox-row-3-2'])}</p>*/}
            {/*    </ThirdRowMessage>*/}
            {/*</LoginRightBox>*/}
        </>
    );
};

export default SignUpLayerContainer;